module.exports = __webpack_public_path__ + "img/advantage_03.e5256edd.jpg";